export default __webpack_public_path__ + "static/media/gameswalla-logo.7ec63b19.png";